import { render, staticRenderFns } from "./levelTwoMenu.vue?vue&type=template&id=079495c2&scoped=true"
import script from "./levelTwoMenu.vue?vue&type=script&lang=js"
export * from "./levelTwoMenu.vue?vue&type=script&lang=js"
import style0 from "./levelTwoMenu.vue?vue&type=style&index=0&id=079495c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079495c2",
  null
  
)

export default component.exports